// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"FieldVolumeType__itemWrapper--1FlmM","region":"FieldVolumeType__region--g3XHR","price":"FieldVolumeType__price--2q8qY"};